const colors = {
  "primary-background": "#6F3FF5",
  "secondary-background": "#0E0333",
  "danger-background": "#D03E63",
  "primary-text": "#0E0333",
  "secondary-text": "#757087",
  "tertiary-text": "#E2E0E7",
  "quaternary-text": "#FFFFFF",
  "green-text": "#11BC92",
};
export default colors;
